import api from '../../services/pipeline';
export default function (helper) {

    /**
     * Generated store module
     */
    helper.setApi(api);
    const types = helper.types('pipeline');
    const state = helper.state();
    const getters = helper.getters();
    const actions = helper.actions({}, 'Pipeline');
    const mutations = helper.mutations({}, types, state);

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
}